import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import Filme from "./pages/Filme";
import Header from "./components/Header";
import Notfound from "./pages/Notfound";
import Favoritos from "./pages/Favoritos";

function RoutesApp(){
  return(
    <BrowserRouter>
    <Header/>
    <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/Filme/:id" element={<Filme/>} />
        <Route path="/favoritos" element={<Favoritos/>} />

        <Route path="*" element={<Notfound/>} />
    </Routes>
    </BrowserRouter>
  )
}

export default RoutesApp;